<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-money-check-alt"></i> <ng-container i18n>Create a Tax</ng-container></h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="row">
    <div class="col-sm-4">
      <mat-form-field2 class="mat-block">
        <input type="text" formControlName="name" matInput required placeholder="Tax Name:" i18n-placeholder />
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
          <ng-container i18n>Tax name is required</ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('minlength')">
          <ng-container i18n>Tax name must be at least 2 characters long</ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('maxlength')">
          <ng-container i18n>Tax name must be at most 50 characters long</ng-container>
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-sm-4">
      <mat-form-field2 class="mat-block">
        <mat-label><span [innerHtml]="form.get('type').value | amountPlaceholder : currencySymbol"></span></mat-label>
        <input type="number" min="0" formControlName="amount" matInput decimal required />
        <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')">
          <ng-container i18n>Amount is required</ng-container>
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-sm-4">
      <mat-form-field2 class="mat-block">
        <mat-select formControlName="type" placeholder="Type" i18n-placeholder>
          <mat-option value="percent" i18n>Percent</mat-option>
          <mat-option value="flat" i18n>Flat</mat-option>
        </mat-select>
      </mat-form-field2>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="far fa-plus"></i> <ng-container i18n>create</ng-container>
  </button>
</div>
